<template>
  <button :style="btnColorSet" @click="btnClicked" :disabled="disabled">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'SimpleButton',
  props: {
    colorStyle: {
      type: String,
      required: false,
      default: 'regular'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    btnColorSet() {
      if (this.colorStyle === 'outline') {
        return {
          backgroundColor: 'transparent',
          borderColor: '#FF6C01',
          color: '#FF6C01',
        };
      }
      return {
        backgroundColor: '#FF6C01',
        borderColor: '#FF6C01',
        color: '#fff',
      }
    }
  },
  methods: {
    btnClicked(evt) {
      this.$emit('click', evt);
    },
  }
}
</script>

<style scoped lang="scss">
button {
  display: inline-block;
  padding: 1rem 1rem;
  border-width: 1px;
  border-style: solid;
  border-color: #000;
  border-radius: 999px;
  transition: opacity .4s ease;
  width: 100%;
  &:hover {
    opacity: .6;
  }
  &:disabled {
    opacity: .4;
  }
}

</style>